/* @flow */
import { apiService } from 'services/ServiceRegistry';
import { activities } from 'components/Activity/ActivityData.js';

import navigation from 'services/NavigationService';

import Form from '../_.extend';

export const makeFields: Function = (itemData: Object, t: Function) => [
  {
    name: 'manufacturerDetail',
    label: t('general:manufacturers.labels.details'),
    fields: [
      {
        name: 'manufacturerName',
        label: t('general:manufacturer'),
        rules: 'required|string',
        ...(itemData ? { value: itemData.name } : null),
        extra: {
          selectID: itemData ? itemData.id : null,
          resetValue: itemData || null,
          resetValueFields: [
            {
              field: 'manufacturerName',
              value: 'name',
            },
            {
              field: 'manufacturerCode',
              value: 'code',
            },
            {
              field: 'manufacturerShortCode',
              value: 'short_code',
            },
            {
              field: 'keyOEM',
              value: 'key_oem',
              condition: {
                if: true,
                ifVal: 'Yes',
                elseVal: 'No',
              },
            },
            {
              field: 'manufacturerStatus',
              value: 'status',
              condition: {
                if: 'Approved',
                ifVal: 'Approved',
                elseVal: 'Not Approved',
              },
            },
          ],
          toggleToTextField: true,
          isTextField: true,
          textTitle: 'Choose existing',
          title: 'Use original',
          setSelectedFields: [
            {
              field: 'manufacturerCode',
              value: 'code',
            },
            {
              field: 'manufacturerShortCode',
              value: 'short_code',
            },
            {
              field: 'keyOEM',
              value: 'key_oem',
              condition: {
                if: true,
                ifVal: 'Yes',
                elseVal: 'No',
              },
            },
            {
              field: 'manufacturerStatus',
              value: 'status',
              condition: {
                if: 'Approved',
                ifVal: 'Approved',
                elseVal: 'Not Approved',
              },
            },
          ],
        },
      },
      {
        name: 'manufacturerId',
        label: t('general:manufacturers.labels.id'),
        rules: 'string',
        ...(itemData ? { value: itemData.id } : null),
      },
      {
        name: 'manufacturerKey',
        label: t('general:manufacturers.labels.key'),
        rules: 'string',
        ...(itemData ? { value: itemData.key } : null),
      },
      {
        name: 'manufacturerCode',
        label: t('general:manufacturers.labels.code'),
        rules: 'required|string',
        ...(itemData ? { value: itemData.code } : null),
      },
      {
        name: 'manufacturerShortCode',
        label: t('general:manufacturers.labels.short_code'),
        rules: 'required|string',
        ...(itemData ? { value: itemData.short_code } : null),
      },
      {
        name: 'manufacturerAlias',
        label: t('general:manufacturers.labels.alias'),
        rules: 'string',
        placeholder: 'Type alias and press Enter',
        value: null,
      },
      {
        name: 'keyOEM',
        label: t('general:manufacturers.labels.key_oem'),
        rules: 'required|string',
        options: [
          {
            id: 'Yes',
            label: 'Yes',
            value: 'Yes',
          },
          {
            id: 'No',
            label: 'No',
            value: 'No',
          },
        ],
        ...(itemData ? { value: itemData.key_oem ? 'Yes' : 'No' } : null),
      },
      {
        name: 'manufacturerStatus',
        label: t('general:labels.status'),
        rules: 'required|string',
        ...(itemData
          ? {
              value: itemData.status === 'Approved' ? 'Approved' : 'Not Approved',
            }
          : { value: 'Not Approved' }),
        type: 'select',
        placeholder: 'Status',
        options: [
          {
            id: 'Approved',
            label: 'Approved',
          },
          {
            id: 'Not Approved',
            label: 'Not Approved',
          },
        ],
      },
      {
        name: 'globalList',
        label: t('general:labels.global_list'),
        rules: 'required|boolean',
      },
    ],
  },
];

class ManufacturerDetailCreate extends Form {}

class ManufacturerDetailEdit extends Form {}

export const manufacturerCreate: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const {
        manufacturerName,
        manufacturerCode,
        manufacturerShortCode,
        keyOEM,
      }: Object = form.values().manufacturerDetail;

      apiService
        .createResource('manufacturers', {
          activity_tag: activities.createdManufacturer.tag, // eslint-disable-line camelcase
          name: manufacturerName,
          code: manufacturerCode,
          short_code: manufacturerShortCode,
          alias:
            localState.aliases && localState.aliases.length > 0 ? localState.aliases.join(',') : '',
          key_oem: Boolean(keyOEM.toLowerCase() === 'yes'),
          status: 'Approved',
          global_list: form.$('manufacturerDetail.globalList').value,
        })
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new ManufacturerDetailCreate(
    { fields },
    { hooks, name: t('general:actions.create_new_manufacturer') }
  );
};

export const manufacturerEdit: Function = (
  fields: Array<*>,
  data: string,
  localState: Object,
  t: Function
) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const {
        manufacturerName,
        manufacturerCode,
        manufacturerShortCode,
        keyOEM,
        manufacturerStatus,
      }: Object = form.values().manufacturerDetail;

      const selectedManId = form.$('manufacturerDetail.manufacturerName').extra.selectID;

      if (data.status === 'Pending Review' && data.id !== selectedManId) {
        apiService
          .putResource(`manufacturers/${selectedManId}/merge`, {
            manufacturer_id: data.id,
          })
          .then((response: Object) => {
            localState.isLoading = false;
            localState.responseMessage = t('general:messages.save_success');

            setTimeout(() => {
              localState.showResponseMessage = false;
              /*eslint-disable max-nested-callbacks*/
              setTimeout(() => {
                // Snackbar animation 225ms
                navigation.goBack();
              }, 225);
            }, 1200);

            return response;
          })

          .catch((err: string) => {
            localState.isLoading = false;
            localState.responseMessage = t('general:messages.save_error');
            localState.hasSuccess = false;
            localState.hasError = true;
          });
      } else {
        apiService
          .putResource(`manufacturers/${data.id}`, {
            activity_tag: activities.edited.tag, // eslint-disable-line camelcase
            name: manufacturerName,
            code: manufacturerCode,
            short_code: manufacturerShortCode,
            alias:
              localState.aliases && localState.aliases.length > 0
                ? localState.aliases.join(',')
                : '',
            key_oem: Boolean(keyOEM.toLowerCase() === 'yes'),
            status: manufacturerStatus,
            global_list: form.$('manufacturerDetail.globalList').value,
          })
          .then((response: Object) => {
            localState.isLoading = false;
            localState.responseMessage = t('general:messages.save_success');

            setTimeout(() => {
              localState.showResponseMessage = false;
              /*eslint-disable max-nested-callbacks*/
              setTimeout(() => {
                // Snackbar animation 225ms
                navigation.goBack();
              }, 225);
            }, 1200);

            return response;
          })

          .catch((err: string) => {
            localState.isLoading = false;
            localState.responseMessage = t('general:messages.save_error');
            localState.hasSuccess = false;
            localState.hasError = true;
          });
      }
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new ManufacturerDetailEdit(
    { fields },
    { hooks, name: t('general:actions.edit_manufacturer') }
  );
};
